import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ChevronDownIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.96967 5.46967C3.26256 5.17678 3.73744 5.17678 4.03033 5.46967L8.5 9.93934L12.9697 5.46967C13.2626 5.17678 13.7374 5.17678 14.0303 5.46967C14.3232 5.76256 14.3232 6.23744 14.0303 6.53033L9.03033 11.5303C8.73744 11.8232 8.26256 11.8232 7.96967 11.5303L2.96967 6.53033C2.67678 6.23744 2.67678 5.76256 2.96967 5.46967Z'
      />
    </SvgIcon>
  );
}
